import React from 'react';
import GlobalizationSelector from '@homeaway/react-globalization-selector';
import URLSearchParams from 'url-search-params';

export default class GlobalizationSelectorConnector extends React.Component {
    getRedirectUrl = (locale, siteUrl, currency) => {
        let countryCode = locale.split('_')[1].toLowerCase();
        let origin;
        let params;

        if (countryCode === this.props.countryCode) {
            origin = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
            params = new URLSearchParams(window.location.search);
        } else {
            origin = siteUrl.replace(/\/$/, '');
            params = new URLSearchParams();
        }

        if (this.props.languageCode !== locale) {
            params.set('gx-locale', locale);
        }
        if (this.props.currencyCode !== currency) {
            params.set('gx-currency', currency);
        }

        return `${origin}${params.toString() !== '' ? `?${params.toString()}` : ''}`;
    };

    handleChangeGlobalSelector = (locale, siteUrl, currency) => {
        if (window && window.location) {
            const redirectUrl = this.getRedirectUrl(locale, siteUrl, currency);

            if (this.props.onGlobalSelectorChange) {
                this.props.onGlobalSelectorChange({
                    redirectUrl,
                    locale,
                    currency,
                    siteUrl
                });
            } else {
                window.location.assign(redirectUrl);
            }
        }
    };

    render() {
        return <GlobalizationSelector {...this.props} onGlobalSelectorChange={this.handleChangeGlobalSelector} />;
    }
}
